import script from "./PhaseReceivedItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./PhaseReceivedItem.vue?vue&type=script&lang=ts&setup=true"

import "./PhaseReceivedItem.vue?vue&type=style&index=0&id=7d327862&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d327862"]])

export default __exports__